<template>
  <router-view v-if="!$apollo.loading" />
</template>

<script>
export default {
  name: "Templates"
};
</script>
